import {
	initObservability,
	logInfo as _logInfo,
	logError as _logError,
	addRumError as _addRumError,
	setUserContext as _setUserContext,
	clearUserContext as _clearUserContext,
	getCorrelationKey as _getCorrelationKey,
	isInitialized as _isInitialized,
	setupAxiosObservability,
	ObservabilityErrorBoundary
} from '@webmotors/anunciar.tools';
import { ENV } from '@/app/config';
import { getBuildVersion } from './build-version';

/**
 * Inicializa Datadog RUM + Logs + Session Replay via @webmotors/anunciar.tools.
 *
 * Deve ser chamado uma única vez no entry point (main.tsx), antes de
 * qualquer componente renderizar. O correlation-id é gerado automaticamente
 * e armazenado em sessionStorage. Todas as chamadas de logInfo/logError já
 * incluem o correlation_id.
 *
 * Em desenvolvimento (clientToken vazio), a lib pula a inicialização
 * silenciosamente — não há necessidade de guard extra.
 */
const initDatadog = () => {
	initObservability({
		provider: 'datadog',
		config: {
			team: 'anunciar',
			isDev: ENV.AUTH_ENV === 'development',
			enableRum: true,
			enableLogs: true,
			enableSessionReplayRecording: true,
			shared: {
				clientToken: ENV.DATADOG_CLIENT_TOKEN,
				env: ENV.DATADOG_ENV,
				service: ENV.DATADOG_SERVICE,
				site: ENV.DATADOG_SITE,
				version: getBuildVersion()
			},
			rum: {
				applicationId: ENV.DATADOG_APPLICATION_ID,
				sessionSampleRate: ENV.DATADOG_SESSION_SAMPLE_RATE,
				sessionReplaySampleRate: ENV.DATADOG_SESSION_REPLAY_SAMPLE_RATE,
				trackResources: true,
				trackLongTasks: true,
				defaultPrivacyLevel: 'mask-user-input',
				trackUserInteractions: true,
				errorSampling: {
					enabled: true,
					ttlMs: 60_000
				}
			},
			logs: {
				sessionSampleRate: 100
			}
		}
	});
};

/**
 * Reexports de `@webmotors/anunciar.tools`. Outros módulos devem importar
 * a partir de `@/services/observability` — nunca direto do pacote — para
 * manter a dependência encapsulada.
 */
const logInfo = _logInfo;
const logError = _logError;
const addRumError = _addRumError;
const setUserContext = _setUserContext;
const clearUserContext = _clearUserContext;
const getCorrelationKey = _getCorrelationKey;
const isInitialized = _isInitialized;

export {
	initDatadog,
	logInfo,
	logError,
	addRumError,
	setUserContext,
	clearUserContext,
	getCorrelationKey,
	isInitialized,
	setupAxiosObservability,
	ObservabilityErrorBoundary
};
